import React from "react";
import {observer} from "mobx-react-lite";
import {grid} from "../stores/GridStore";
import "./Grid.css";

export const Grid = observer(() => {

    let cellsGrid: JSX.Element[] = [];

    for (let y = grid.rows - 1; y >= 0; y--) {
        cellsGrid.push(<div key={`r-${y}`} className="row-header">{y}</div>);
        for (let x = 0; x < grid.columns; x++) {
            // const color = `rgb(255,255,255)`;
            // const color = grid.cells[x][y].value < 0 ? "rgb(255,34,68)" : "rgb(255,255,255)";
            // const color = grid.cells[x][y].color >= 0 ? grid.cells[x][y].color
            // const v = grid.cells[x][y].value && !isNaN(grid.cells[x][y].value) ? grid.cells[x][y].value : '-';
            // const v = grid.cells[x][y].value;
            cellsGrid.push(
                <div key={(x << 8) + y} className={`linn-color-${grid.cells[x][y].color || '0'} cell `}>
                    <div className="grid-cell-content">
                        {/*{x}.{y}<br />*/}
                        {grid.cells[x][y].value}
                        {/*{v}<br />*/}
                        {/*{grid.cells[x][y].color || "0"}*/}
                    </div>
                </div>
            );
        }
    }
    cellsGrid.push(<div key="0-0" className=""></div>);
    for (let x = 0; x < grid.columns; x++) {
        cellsGrid.push(<div key={`c-${x}`} className="col-header">{x}</div>);
    }

    return (
        <div className={`grid linn${grid.model}`}>
            <div className={`cells`}>
                {cellsGrid}
{/*
                {grid.cells.map(
                    (col, y) => {
                        if (col) {
                            return col.map((cell, x) =>
                                <div>{x}.{y}</div>)
                        } else {
                            return null;
                        }
                    }
                )}
*/}
{/*
                <pre>
                {JSON.stringify(grid.cells, null, 4)}
                </pre>
*/}
            </div>
        </div>
    );

});
